export default function RoomSharedIconColor({
  ...props
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 66 66" {...props}>
      <path
        fill="#ef6561"
        stroke="#101f2d"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="2"
        d="m58.9 28.6-24-18.2c-1.1-.9-2.7-.9-3.9 0L7.2 28.5c-.6.4-1.2.7-1.9.7-3 0-4.4-3.8-2-5.7l25.6-20c2.4-1.9 5.8-1.9 8.2 0l25.7 20.1c2.4 1.9 1.1 5.7-2 5.7-.7-.1-1.4-.3-1.9-.7z"
      />
      <path
        fill="none"
        stroke="#101f2d"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="2"
        d="M11.1 38.3v1.9a7.81 7.81 0 0 0 15.6 0v-1.9"
      />
      <path
        fill="none"
        stroke="#101f2d"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="2"
        d="M14.2 46.4v4.2l-5.8 1.2a4.7 4.7 0 0 0-3.7 4.6v4.1c0 1.9 1.5 3.4 3.4 3.4h21.4c1.9 0 3.4-1.5 3.4-3.4v-4.1c0-2.2-1.5-4.1-3.7-4.6L24 50.6v-4.1"
      />
      <path
        fill="#64c4f6"
        stroke="#101f2d"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="2"
        d="M26.7 38.3c-3-.2-4.2-4.3-7.4-4.6-3.5.4-2.7 3.6-2.7 3.6-2.8-1.3-2.1-3.6-2.1-3.6s-3.8 1.4-3.4 4.6-2.2-9.4 6-10.9c0 0 4-1 6.5 2 .1 0 5.4-.9 3.1 8.9z"
      />
      <path
        fill="none"
        stroke="#101f2d"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="2"
        d="M39.4 38.3v1.9a7.81 7.81 0 0 0 15.6 0v-1.9"
      />
      <path
        fill="none"
        stroke="#101f2d"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="2"
        d="M42.5 46.4v4.2l-5.8 1.2a4.7 4.7 0 0 0-3.7 4.6v4.1c0 1.9 1.5 3.4 3.4 3.4h21.4c1.9 0 3.4-1.5 3.4-3.4v-4.1c0-2.2-1.5-4.1-3.7-4.6l-5.3-1.2v-4.1"
      />
      <path
        fill="#ef6561"
        stroke="#101f2d"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="2"
        d="M55 38.3c-3-.2-4.2-4.3-7.4-4.6-3.5.4-3.1 3.6-3.1 3.6-2.8-1.3-2-3.8-2-3.8S39 35 39.4 38.2s-2.2-9.4 6-10.9c0 0 4-1 6.5 2 0 .1 5.4-.8 3.1 9z"
      />
      <g
        stroke="#101f2d"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="2"
      >
        <path fill="none" d="M16.9 12.8V7.2h-6.4v10.5" />
        <path fill="#64c4f6" d="M8.5 2.4h10.3v4.8H8.5z" />
        <path
          fill="none"
          d="m24 50.6-.2.2a7.67 7.67 0 0 1-9.6-.2L19.1 64zM52.2 50.6l-.2.2a7.67 7.67 0 0 1-9.6-.2L47.3 64zM25.7 57.5h3.2M54 57.5h3.2"
        />
      </g>
    </svg>
  );
}
